<template>
    <div class="proposal-application">
        <div v-if="current_customer && (current_customer.ssa || current_customer.se)">
            <b-row>
                <b-col class="d-flex justify-content-end mb-3">
                    <el-button class="bg-primary text-white" @click="createInitialProposalHandler" :loading="is_loading_create">
                       <b-icon icon="file-earmark-fill"></b-icon> New Proposal
                    </el-button>
                </b-col>
            </b-row>    
            <b-card no-body v-if="is_loading" v-loading="is_loading">
                <div class="bg-light p-5 text-center rounded">
                </div>
            </b-card>
            <div v-if="initial_proposals.length === 0 && !is_loading">
                <div class="card">
                    <div class="bg-light p-3 text-center rounded"> No proposal found. </div>
                </div>
            </div>
            <b-card no-body class="p-3 mb-3" v-for="(initial_proposal, index) in initial_proposals" :key="index">
                <b-row align-h="between">
                    <b-col cols="6" md="4">
                        <b-badge class="text-white font-weight-400 badge-id mr-1">ID</b-badge>
                        <span class="text-muted text-xs">{{ initial_proposal.psal_id }} | Created in {{ initial_proposal.psal_created_date | dateFormatString }}</span>
                    </b-col>
                    <b-col cols="6" md="auto">
                        <small>Proposal has been 
                            <span class="font-weight-600" :style="{color: IP_STATUS_COLOR[initial_proposal.psal_main_status] }">{{ initial_proposal.psal_main_status }}</span> 
                            <span 
                                v-if="initial_proposal.psal_main_status === 'Submitted to SSA'"
                            > at <span class="font-weight-600">{{ initial_proposal.psal_submited_ssa_date | dateTimeFormatString }}</span>
                            </span>
                            <span 
                                v-if="initial_proposal.psal_main_status === 'Submitted to Credit Control'"
                            > at <span class="font-weight-600">{{ initial_proposal.psal_submited_cc_date | dateTimeFormatString }}</span>
                            </span>.
                        </small>
                        <el-dropdown trigger="click" class="cursor-pointer">
                            <b class="el-dropdown-link">
                                <b-icon icon="three-dots-vertical">
                                </b-icon>
                            </b>
                            <el-dropdown-menu slot="dropdown">
                                <!-- <el-dropdown-item>
                                    Appeal Request
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    Generate Invoice
                                </el-dropdown-item> -->
                                <el-dropdown-item class="text-danger">
                                   <a href="javascript:void(0)" 
                                    class="text-danger d-block"
                                    @click="deleteInitialProposalHandler(initial_proposal.psal_id, index)"
                                    v-if="
                                        !IP_APPROVED_STATUSES.includes(initial_proposal.psal_main_status)
                                        &&
                                        auth_user.id === initial_proposal.psal_created_by
                                    "
                                >Delete</a> 
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col cols="12" md="4" class="mb-2">
                        <p class="text-xs">Total Settlement Strategy</p>
                        <p class="font-weight-500 mb-2">RM {{ (
                            parseFloat(initial_proposal.summary_ccris_track.total_inv_settlement) + 
                            parseFloat(initial_proposal.summary_ccris_track.total_merchant_settlement) + 
                            parseFloat(initial_proposal.summary_ccris_track.total_other_settlement) 
                        ) | moneyFormatter }}</p>
                        <div class="d-flex align-items-center">
                            <div class="d-flex align-items-center" v-if="initial_proposal.summary_ccris_track.total_inv_settlement > 0">
                                <svg xmlns="http://www.w3.org/2000/svg" class="mx-1" width="8" height="8" viewBox="0 0 512 512"><path fill="#73839C" d="M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208Z"/></svg>
                                <p class="text-xs">{{ 
                                    (parseFloat(initial_proposal.summary_ccris_track.total_inv_settlement) /
                                    (parseFloat(initial_proposal.summary_ccris_track.total_inv_settlement) + 
                                    parseFloat(initial_proposal.summary_ccris_track.total_merchant_settlement) + 
                                    parseFloat(initial_proposal.summary_ccris_track.total_other_settlement)) * 100).toFixed(2) 
                                }} % Invinity</p>
                            </div>
                            <div class="d-flex align-items-center" v-if="initial_proposal.summary_ccris_track.total_merchant_settlement > 0">
                                <svg xmlns="http://www.w3.org/2000/svg" class="mx-1" width="8" height="8" viewBox="0 0 512 512"><path fill="#73839C" d="M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208Z"/></svg>
                                <p class="text-xs">{{ 
                                    (parseFloat(initial_proposal.summary_ccris_track.total_merchant_settlement) /
                                    (parseFloat(initial_proposal.summary_ccris_track.total_inv_settlement) + 
                                    parseFloat(initial_proposal.summary_ccris_track.total_merchant_settlement) + 
                                    parseFloat(initial_proposal.summary_ccris_track.total_other_settlement)) * 100).toFixed(2) 
                                }} % Merchant</p>
                            </div>
                            <div class="d-flex align-items-center" v-if="initial_proposal.summary_ccris_track.total_other_settlement > 0">
                                <svg xmlns="http://www.w3.org/2000/svg" class="mx-1" width="8" height="8" viewBox="0 0 512 512"><path fill="#73839C" d="M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208Z"/></svg>
                                <p class="text-xs">{{ 
                                    (parseFloat(initial_proposal.summary_ccris_track.total_other_settlement) /
                                    (parseFloat(initial_proposal.summary_ccris_track.total_inv_settlement) + 
                                    parseFloat(initial_proposal.summary_ccris_track.total_merchant_settlement) + 
                                    parseFloat(initial_proposal.summary_ccris_track.total_other_settlement)) * 100).toFixed(2) 
                                }} % Other</p>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" md="8">
                        <p class="font-weight-500">Proposed Application</p>
                        <b-row class="mt-2 justify-content-center justify-content-md-start" align-v="center">
                            <div class="d-flex justify-content-between w-100">
                                <b-row class="w-100">
                                    <b-col cols="6" md="5" v-for="(product,index) in initial_proposal.product_applications.slice(0,2)" :key="index">
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <svg v-if="product.pcom_product_detail.pcp_product_type.toLowerCase() === 'mortgage'" xmlns="http://www.w3.org/2000/svg" class="mr-2" width="24" height="20" viewBox="0 0 576 512"><path fill="#5D79E3" d="M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"/></svg>
                                                <svg v-if="product.pcom_product_detail.pcp_product_type.toLowerCase() === 'property'" xmlns="http://www.w3.org/2000/svg" class="mr-2" width="20" height="20" viewBox="0 0 24 24"><path fill="#5D79E3" d="M19 2H9c-1.103 0-2 .897-2 2v5.586l-4.707 4.707A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm-8 18H5v-5.586l3-3 3 3V20zm8 0h-6v-4a.999.999 0 0 0 .707-1.707L9 9.586V4h10v16z"></path><path fill="#A4B0C0" d="M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 1h2v2H7z"></path></svg>
                                                <svg v-if="product.pcom_product_detail.pcp_product_type.toLowerCase() === 'personal_loan'" xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 576 512" class="mr-2"><path fill="#5D79E3" d="M312 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-6-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm256.2 312.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"></path></svg>
                                                <svg v-if="product.pcom_product_detail.pcp_product_type.toLowerCase() === 'insurance'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-2 bi bi-shield-plus" viewBox="0 0 16 16"><path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56"/><path d="M8 4.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V9a.5.5 0 0 1-1 0V7.5H6a.5.5 0 0 1 0-1h1.5V5a.5.5 0 0 1 .5-.5"/></svg>
                                                <svg v-if="product.pcom_product_detail.pcp_product_type.toLowerCase() === 'refinance'" xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 16 16"><path fill="#A4B0C0" d="M12.1.3A1.5 1.5 0 0 1 14 1.8V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9A1.5 1.5 0 0 1 1.4 3L12.1.3zM5.6 3H13V1.8a.5.5 0 0 0-.6-.5zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>
                                                <svg v-if="product.pcom_product_detail.pcp_product_type.toLowerCase() === 'other'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-2 bi bi-grid-fill" viewBox="0 0 16 16"><path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z"/></svg>
                                            </div>
                                            <div class="d-block text-truncate">
                                                <span class="font-xs">{{ product.pcom_product_detail.pcp_product_type.replace('_', ' ') | formatUserName }}</span>
                                                <p class="font-weight-500" 
                                                    v-if="[
                                                        'PROPERTY',
                                                        'MORTGAGE',
                                                        'PERSONAL_LOAN',
                                                        'REFINANCE'
                                                    ]
                                                    .includes(product.pcom_product_detail.pcp_product_type)">RM {{ product.pcom_product_detail.pcp_loan_amount | moneyFormatter }}</p>
                                                <p class="font-weight-500" 
                                                    v-if="
                                                        product.pcom_product_detail.pcp_product_type === 'INSURANCE' &&
                                                        product.pcom_product_detail.pcp_project_json.prod_ins_premium_pa
                                                    "
                                                    >RM {{ product.pcom_product_detail.pcp_project_json.prod_ins_premium_pa | moneyFormatter }}</p>
                                                <p class="font-weight-500" 
                                                    v-if="
                                                        product.pcom_product_detail.pcp_product_type === 'OTHER' &&
                                                        product.pcom_product_detail.pcp_project_json.prod_oth_value
                                                    "
                                                    >RM {{ product.pcom_product_detail.pcp_project_json.prod_oth_value | moneyFormatter }}</p>
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col v-if="initial_proposal.product_applications.length === 0">
                                        <p class="pl-3">No Products Found.</p>
                                    </b-col>
                                </b-row>
                                <b-col cols="auto" class="d-flex align-items-center">
                                    <p class="font-weight-600 text-primary" v-if="initial_proposal.product_applications.length > 2">
                                        +{{ initial_proposal.product_applications.length - 2 }}
                                    </p>
                                    <div @click="viewProposal(initial_proposal)" class="cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#5D79E3" d="M9.4 18 8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6Z"/></svg>
                                    </div>
                                </b-col>
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row v-if="initial_proposal.psal_created_by_detail">
                    <b-col>
                        <small class="badge badge-secondary">Created By {{ initial_proposal.psal_created_by_detail.name }}</small>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <div class="card" v-else>
            <div class="bg-light p-3 text-center rounded"> Please assign an SSA. </div>
        </div>
    </div>
</template>
<script>
    import { Card, Button, Tag, Dropdown, DropdownMenu, DropdownItem, Divider, Select, Option, Input } from 'element-ui'
    import { mapState, mapActions } from 'pinia'
    import {
			notifyFunctionMixin,
			axios,
			services,
			getHeader,
			debounce
    } from '@/assets/js/httpImports.js'
    import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
    import { useCustomerStore } from '@/stores/customerStore'
    import { useAuthStore } from '@/stores/authStore'
		import { useInitialProposalStore } from '@/stores/initialProposalStore'
    import {IP_APPROVED_STATUSES} from '@/assets/js/status.js'
    import {IP_STATUS_COLOR} from '@/assets/js/colors.js'

    export default {
        name: 'proposal',
        mixins: [notifyFunctionMixin],
        components: {
            [Card.name]: Card,
            [Button.name]: Button,
            [Tag.name]: Tag,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Divider.name]: Divider,
            [Select.name]: Select,
            [Option.name]: Option,
            [Input.name]: Input,
        },
        data() {
            return {
                first_load: true,
                IP_STATUS_COLOR:IP_STATUS_COLOR,
                IP_APPROVED_STATUSES:IP_APPROVED_STATUSES,
                is_loading_create: false,
                initial_proposals: [],
                edit_proposal: null,
                is_loading: false,
            }
        },
        computed:{
            ...mapState(useCustomerStore,['current_customer']),
            ...mapState(useAuthStore,['auth_user']),
        },
        mounted(){
            initialProposalEventBus.$on('refresh-proposals', this.getInitialProposals);
        },
        beforeUnmount(){
            initialProposalEventBus.$off('refresh-proposals', this.getInitialProposals)
        },
        created(){
            this.getInitialProposals()
        },
        methods:{
						...mapActions(useInitialProposalStore, ['getProposalList','getProposal','setPerPage','setCurrentPage']),
            viewProposal(proposal){
							this.$router.push({ path: '/initialProposalDetails/'+proposal.psal_id });
						},
            getInitialProposals(){
                this.is_loading = true
                let urlSearchParams = new URLSearchParams();
                urlSearchParams.append('pagination[order][psal_id]', "DESC")
                urlSearchParams.append('search[psal_customer_id]', this.$route.params.customer_id)
                const url = `${services.initial_proposal}proposals?${urlSearchParams.toString()}`;
                axios.get(url, {headers:getHeader()})
                    .then(res=>{
                        this.is_loading = false
                        this.initial_proposals = res.data.content
                        if(this.edit_proposal){
                            let foundProposal = this.initial_proposals.find((item) => item.psal_id === this.edit_proposal.psal_id)
                            if(foundProposal){
                                this.edit_proposal = foundProposal
                            }else{
                                this.edit_proposal = null
                            }
                        }
                        if(this.$route.query.active === 'proposal' && this.$route.query.proposal_id && this.first_load){
                            const proposal = this.initial_proposals.find((item) => item.psal_id === parseInt(this.$route.query.proposal_id))
                            if(proposal){
                                this.viewProposal(proposal)
                            }
                            this.first_load = false
                        }
                    })
                    .catch(e => {
                        this.is_loading = false
                        this.errorFunction(e)
                    })
            },
            async createInitialProposalHandler(){
                this.is_loading_create = true
                try{
                    const data = {
                        "psal_customer_id": this.$route.params.customer_id,
                        "psal_main_status": 'Draft',
                        "psal_sub_status": 'Draft',
                        "psal_management_status": null
                    }
                    const res = await axios.post(services.initial_proposal + 'proposal', data, {headers:getHeader()})
                    this.is_loading_create = false
                    this.notifySuccess('<b>Proposal</b> - Successfully Created.')
                    this.getInitialProposals()
                }catch(e){
                    this.is_loading_create = false
                    this.errorFunction(e)
                }
            },
            async deleteInitialProposalHandler(proposal_id, index){
                try{
                    const res = await axios.post(services.initial_proposal + 'proposal/delete/' +proposal_id, null, {headers:getHeader()})
                    this.notifySuccess('<b>Proposal</b> - Successfully Removed.')
                    this.initial_proposals.splice(index, 1)
                }catch(e){
                    this.errorFunction(e)
                }
            }
        }
    }
</script>